"use client";

import type { PropsWithChildren } from "react";
import { Toaster } from "sonner";

import QueryProvider from "./QueryProvider";
import { AuthProvider } from "./auth/auth-context";
import { ThemeProvider } from "./theme";
import { DEFAULT_LOCALE } from "@/i18n/config";
import { useAppLocale } from "@/i18n/context";
import { TrendyProvider } from "@/lib/trendy";

export function AppProviders({ children }: PropsWithChildren) {
  const locale = useAppLocale();

  return (
    <QueryProvider>
      <AuthProvider>
        <ThemeProvider>
          <TrendyProvider>
            {children}
            <Toaster
              position="top-center"
              richColors
              dir={locale === DEFAULT_LOCALE ? "rtl" : "ltr"}
              toastOptions={{ style: { fontFamily: "var(--font-sans)" } }}
            />
          </TrendyProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
